import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { InfoOverlayComponent } from '@shared/components';
import { SortOrderEnum } from '@shared/enums';
import { TableColumn } from '@shared/interfaces';
import { orderBy } from 'lodash';
import { ButtonModule } from 'primeng/button';
import { MultiSelect, MultiSelectModule } from 'primeng/multiselect';
import { OrderList, OrderListModule } from 'primeng/orderlist';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-sort-table[columns][sortChanged]',
    standalone: true,
    imports: [
        TranslateModule,
        FormsModule,
        ButtonModule,
        TooltipModule,
        OrderListModule,
        MultiSelectModule,
        InfoOverlayComponent,
    ],
    templateUrl: './sort-table.component.html',
    styleUrls: ['./sort-table.component.scss'],
})
export class SortTableComponent implements OnChanges {
    @Input() columns: TableColumn<any>[] = [];
    @Output() sortChanged = new EventEmitter<TableColumn<any>[]>();
    @ViewChild('orderList') orderList: OrderList | undefined = undefined;
    @ViewChild('columnsMultiselect') columnsMultiselect!: MultiSelect;

    readonly columnsMinLimit = 1;
    readonly columnsMaxLimit = 5;
    readonly sortOrders = SortOrderEnum;

    canRemoveColum = false;
    selectedColumns: TableColumn<any>[] = [];
    selectedColumnsIds: number[] = [];

    constructor(private translateService: TranslateService) {}

    ngOnChanges(): void {
        const newColumns = orderBy(this.columns, ['sortPriority']).filter(column => column.isSortingActive);
        this.columns.forEach(column => {
            column.name = this.translateService.instant(column.name);
        });
        this.selectedColumnsIds = newColumns.map(c => c.field);
        if (this.orderList) {
            //fixes prime ng bug
            this.orderList.selection = [];
        }
        this.changeColumns();
    }

    changeSortPriority(): void {
        this.selectedColumnsIds = this.selectedColumns.map(c => c.field);
        this.changeColumns(true);
    }

    changeSortOrder(column: TableColumn<any>): void {
        column.sortOrder = column.sortOrder === SortOrderEnum.ASC ? SortOrderEnum.DESC : SortOrderEnum.ASC;
        this.changeColumns(true);
    }

    changeColumns(emitChanges: boolean = false): void {
        if (this.selectedColumnsIds.length === this.columnsMinLimit) {
            let lastColumn = this.columns.find(column => column.field === this.selectedColumnsIds[0]);
            if (lastColumn) lastColumn.isDisabled = true;
        } else {
            this.columns.forEach(column => (column.isDisabled = false));
        }

        const selectedColumns: TableColumn<any>[] = [];
        this.selectedColumnsIds.forEach(columnId => {
            const result = this.columns.find(column => column.field === columnId);
            if (result) selectedColumns.push(result);
        });
        this.selectedColumns = [...selectedColumns];
        this.checkIfCanRemoveColumn();

        this.selectedColumnsIds = [...this.selectedColumnsIds];

        if (emitChanges) {
            this.sortChanged.emit(this.selectedColumns);
        }
    }

    removeColumn(column: TableColumn<any>): void {
        const index = this.selectedColumnsIds.findIndex(el => el === column.field);
        if (index === -1) {
            return;
        }
        this.selectedColumnsIds.splice(index, 1);
        this.changeColumns(true);
    }

    closeColumnsSelection(event: Event): void {
        this.columnsMultiselect.close(event);
        event.stopPropagation();
    }

    private checkIfCanRemoveColumn(): void {
        this.canRemoveColum = this.selectedColumnsIds.length > 1;
    }

    selectionChange(event: any): void {
        if (!event[0] && this.orderList) {
            this.orderList.selection = [];
        }
    }
}
